import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "query", "row", "empty", "master", "labels", "bulk", "selectedCount", "choice", "checkbox", "select", "changes"]
  static values = { status: String }

  connect() {
    this.#rememberInitialValues()
  }

  reset() {
    this.#rememberInitialValues()
    this.statusValueChanged()
  }

  showStatus(event) {
    this.statusValue = event.params.status
  }

  statusValueChanged() {
    this.tabTargets.forEach((tab) => {
      tab.setAttribute("aria-selected", tab.dataset.status === this.statusValue)
    })
    this.filter()
  }

  filter() {
    const query = this.hasQueryTarget ? this.queryTarget.value.trim().toLowerCase() : ""
    this.rowTargets.forEach((row) => {
      row.classList.toggle("hidden", row.dataset.status !== this.statusValue || (query !== "" && !row.dataset.name.includes(query)))
    })
    const visibleIndexes = this.#visibleIndexes()
    this.rowTargets.forEach((row, index) => {
      row.classList.toggle("border-t", index !== visibleIndexes[0])
    })
    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("hidden", visibleIndexes.length > 0)
    this.#clearSelection()
  }

  toggleAll(event) {
    this.#visibleIndexes().forEach((index) => {
      this.checkboxTargets[index].checked = event.target.checked
    })
    this.refreshSelection()
  }

  refreshSelection() {
    const count = this.checkboxTargets.filter((checkbox) => checkbox.checked).length
    this.selectedCountTarget.textContent = `${count} selected`
    this.labelsTarget.classList.toggle("hidden", count > 0)
    this.bulkTarget.classList.toggle("hidden", count === 0)
  }

  apply() {
    const value = this.choiceTarget.value
    this.#visibleIndexes().forEach((index) => {
      const select = this.selectTargets[index]
      if (this.checkboxTargets[index].checked && this.#offers(select, value)) select.value = value
    })
    this.#clearSelection()
  }

  countChanges() {
    const count = this.selectTargets.filter((select, index) => select.value !== this.initialValues[index]).length
    this.changesTarget.textContent = count === 0 ? "No unsaved changes" : `${count} unsaved ${count === 1 ? "change" : "changes"}`
  }

  #rememberInitialValues() {
    this.initialValues = this.selectTargets.map((select) => select.value)
  }

  #visibleIndexes() {
    return this.rowTargets.flatMap((row, index) => (row.classList.contains("hidden") ? [] : [index]))
  }

  #clearSelection() {
    if (!this.hasMasterTarget) return

    this.masterTarget.checked = false
    this.choiceTarget.value = ""
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
    this.refreshSelection()
  }

  #offers(select, value) {
    return Array.from(select.options).some((option) => option.value === value)
  }
}
